import React from "react"
import {
  DOMNode,
  domToReact,
  Element,
  HTMLReactParserOptions,
} from "html-react-parser"
import { ExternalLink } from "components/external-link/ExternalLink"
import { Link } from "gatsby"
import { useLayout } from "contexts/components/LayoutContext"
import { getRelativePathFromCodex } from "components/button/utils/getRelativePathFromCodex"

export const contentParserOptions: HTMLReactParserOptions = {
  replace: (domNode: DOMNode) => {
    const { contentUrlPathCodex } = useLayout()
    if (domNode instanceof Element && domNode.attribs) {
      const { attribs, children } = domNode
      if (!attribs) {
        return
      }
      if (attribs && attribs.hasOwnProperty(`href`)) {
        if (attribs.href.includes("@") || attribs.href.includes("tel:")){
          return (
            <a href={attribs.href}>{domToReact(children, contentParserOptions)}</a>
          )
        }
        if (
          attribs.href?.startsWith("www") ||
          attribs.href?.startsWith("https") ||
          attribs.href?.startsWith("http")
        ) {
          return (
            <ExternalLink
              href={
                attribs.href?.startsWith("www")
                  ? `https://${attribs.href}`
                  : attribs.href
              }
            >
              {domToReact(children, contentParserOptions)}
            </ExternalLink>
          )
        } else {
          const path = getRelativePathFromCodex({
            path: attribs.href,
            codex: contentUrlPathCodex,
            codexKeyStartsWithForwardSlash: true,
          })

          return (
            <Link to={path}>{domToReact(children, contentParserOptions)}</Link>
          )
        }
      }
    }
  },
}
